import React, { useCallback, useEffect, useRef, useState } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from './style.module.scss';
import CRuler from "./ruler";
import { useIntl } from "react-intl";

const SizeRulerBox = props => {
    useStyles(classes)
    const {title, clear, dataList, initValue, unit, valueNow, setValueNow, hideUnit} = props
    const rulerContainer = useRef()
    const Intl = useIntl()

    useEffect(() => {
        if(rulerContainer.current && dataList?.length > 0){
            // console.log('props: ',props)
            const dataValueList = dataList.map(d => d?.[unit] || d)
            let strReg = /[A-Za-z]/ //判断数据是否存在字母
            let params = {
                dataType: 'numbers'
            }
            if(!dataValueList.find(d => typeof(d) == 'object')){
                if(dataValueList.find(d => d?.indexOf('.') != -1 || strReg.test(d))){
                    // 说明存在小数，或者存在字母，走 customer 的配置
                    params['dataType'] = 'customer'
                    params['customerDataList'] = dataValueList
                } else {
                    params['numberRegion'] = [
                        dataValueList?.[0] || 0,
                        dataValueList?.[dataValueList?.length - 1] || 100
                    ]
                }
                params['callback'] = (data) => {
                    setValueNow((data || 0))
                }
                if(initValue){
                    params['initValue'] = initValue
                }
                rulerInitFunc(params)
            } else {
                console.error('数据中存在对象')
            }
        }
    }, [rulerContainer, dataList, unit, initValue])

    useEffect(() => {
        if(clear){
            const canvas = document.querySelector("#cRulerWrap")
            if(canvas){
                document.removeChild(canvas)
            }
        }
    }, [clear])

    useEffect(() => {
        return () => {
            if(rulerContainer?.current){
                rulerContainer.current = null
            }
        }
    },[])

    const rulerInitFunc = useCallback((params) => {
        const actualPx = (px) => {
            // return (2 * px / 75 * 1) + 'rem'
            return px +'px'
        }
        CRuler.initRuler({
            // 通用参数
            targetEl: rulerContainer.current,
            canvasHeight: 100,
            backgroundColor: '#fff',
            fontColor: '#222', // 字体颜色
            fontStyle: `${actualPx(14)} Roboto`, // 字体样式
            lineColor: '#a1a1a1', // 线条颜色
            pointerLineColor: '#222', // 主线条颜色
            pointerHasCircle: true, // 指针是否有圆球
            isConstant: true, // 数据只要变就触发 callback
            callback: (data)=> {
                console.log('CRuler: ',data)
            }, // 回调函数
            initValue: 0,
            startTip: Intl.formatMessage({id:'ruler_min', defaultMessage:'The ruler is at its minimum'}),
            endTip: Intl.formatMessage({id:'ruler_min', defaultMessage:'The ruler is at its maximum'}),
            tipStyle: {
                color: '#999',
                fontSize: `${actualPx(12)}`,
                fontFamily:'Roboto-Regular, Roboto'
            },
            //
            dataType: 'numbers',
            numberBlank: 9,
            numberRegion:[0,100],
            //
            customerDataList: [],
            customerNumberBlank:1, // 两个数字间的间隔 从 0 开始
            customerPageShow:9, // 一页显示几个 从 0 开始
            ...params
        })
    })

    return (
        <div className={classes.RulerWrapBox}>
            <div className={classes.basicInfo}>
                <div className={classes.title}>{title}</div>
                {/* input放当前的数据 */}
                <div className={classes.ValueNow}>
                    {valueNow + ' '}
                    {
                        !hideUnit &&
                        <span style={{textTransform: 'uppercase'}}>{(unit? ` ${unit}`:'')}</span>
                    }
                </div>
            </div>
            <div className={classes.RulerBox} ref={rulerContainer}></div>
        </div>
    )
}

export default SizeRulerBox